import { saveAs } from 'file-saver'

export const exportPdf = async (exportData: Uint8Array) => {
  console.log('exportData:', exportData)
  const blob = new Blob([exportData], { type: 'application/pdf' })
  console.log('blob:', blob)
  saveAs(blob, 'export.pdf')
}
